class DosageDisplayOptions {
    public includeRenewalsOnLastDosage: boolean = true;
    public includeRemainingRenewalCalculation: boolean = true;
    public includeDaysOrQty: boolean = true;
    public includeNarcoticFreq: boolean = true;
    public includeRefillQuantity: boolean = false;

    public constructor(fields?: Partial<DosageDisplayOptions>) {
        Object.assign(this, fields);
    }
}

export { DosageDisplayOptions };
